import React from 'react';
import { AppButton } from '@/components/atoms';
import BottomBar from '@/components/organisms/Footer';

interface Props {
  onRezept: () => void;
  onReset: () => void;
  onRezeptsInvoice: () => void;
  onLongTerm: () => void;
  onGaijiList: () => void;
  onVisitCheck: () => void;
  onKakutei: () => void;
}

const RezeptListActionBar: React.FC<Props> = ({
  onRezept,
  onReset,
  onRezeptsInvoice,
  onLongTerm,
  onGaijiList,
  onVisitCheck,
  onKakutei,
}) => (
  <BottomBar
    variant="action"
    visible
    fixed
    left={
      <>
        <AppButton type="primary" className="rounded" onClick={onRezept}>
          <i className="mr-2 fa fa-print" aria-hidden="true" />
          レセプト発行
        </AppButton>
        <AppButton type="primary" className="rounded" onClick={onReset}>
          <i className="mr-2 fa fa-paper-plane" aria-hidden="true" />
          未印刷に戻す
        </AppButton>
        <AppButton className="rounded" onClick={onRezeptsInvoice}>
          請求患者一覧
        </AppButton>
        <AppButton className="rounded" onClick={onLongTerm}>
          月16回受診者
        </AppButton>
        <AppButton className="rounded" onClick={onGaijiList}>
          外字リスト
        </AppButton>
        <AppButton className="rounded" onClick={onVisitCheck}>
          訪問データチェック
        </AppButton>
      </>
    }
    right={
      <AppButton type="primary" className="rounded" onClick={onKakutei}>
        <i className="mr-2 fa fa-paper-plane" aria-hidden="true" />
        確定
      </AppButton>
    }
  />
);

export default RezeptListActionBar;
